module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "blackquote"
  }, [_c('a', {
    attrs: {
      "id": "file_010"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('em', [_vm._v("Most of the projects in this book require simple materials. A felting needle, wool, and a foam pad are needed for all projects. Resources for where to find these items are listed on ")])]), _c('em', [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/file_516#file_516",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 128")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b4e7aea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_010.vue
// module id = 81
// module chunks = 0